// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nc-0";